module.exports = {"hasQuote":{"href":"#all-shipping","canRequest":"View and request shipping quotes","cannotRequest":"View all shipping quotes"},"noQuote":{"href":"#all-shipping-global","canRequest":"Request a shipping quote","cannotRequest":"View details"}}


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/Blurb.json
// module id = 1838
// module chunks = 4 14